import cn from "classnames"

import { ReactComponent as KodemWordmarkSvg } from "@/assets/icons/kodem-wordmark.svg"

import styles from "./LogoImage.module.scss"

import type { LogoImageProps } from "."

export const LogoImage = ({
  dark,
  className,
  testId = "LogoImage",
  ...props
}: LogoImageProps) => (
  <KodemWordmarkSvg
    role="img"
    aria-label="Logo"
    data-testid={testId}
    className={cn(styles.logo, dark && styles.dark, className)}
    {...props}
  />
)
